<template>
  <v-container>
    <vue-headful title="Registrierung" description="Aimz"/>
    <v-form v-model="valid" ref="form" v-if="!success">
      <v-container style="max-width: 300px;">
        <v-row class="pt-3 pb-3 mb-n10">
          <v-col>
            <center-container>
              <v-img class="ma-5 mb-10" :src="require('@/assets/aimz.svg')" max-width="300"></v-img>
<!--              <v-img class="mb-5" :src="require('@/assets/dyl_logo.svg')" max-width="200" width="200"></v-img>-->
              <p class="title">Verschaffe dir mit 2 Minuten mehr Zeit im Alltag.<br/>
                <span class="body-1">Jetzt die Web-App <b class="dunkelblau--text">aimz</b> gratis sichern.</span>
              </p>
            </center-container>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0">
            <v-text-field name="xyz1" class="full_width" label="Deine Email" v-model="email" :rules="emailRules" type="email" required :readonly="!!member"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0">
            <v-alert v-if="capslock" type="warning">
            FESTSTELLTASTE AKTIV
            </v-alert>
            <v-text-field name="xyz2" class="full_width" placeholder="Passwort" v-model="pw1" :rules="pw1Rules" required type="password" autocomplete="new-password"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0">
            <v-text-field name="xyz3" class="full_width" placeholder="Passwort wiederholen" v-model="pw2" :rules="pw2Rules" required type="password" autocomplete="new-password"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="py-0">
          <v-col>
            <p class="body-2">Mit der Nutzung von Aimz stimmst du der zweckgebundenen Verarbeitung deiner Daten gemäß unserer <router-link to="/datenschutz" target="_blank">Datenschutzerklärung</router-link> zu.</p>
            <v-checkbox v-model="agreeDSB" label="Ich stimme der Datenschutzerklärung zu" :rules="agreeDSBrules" required></v-checkbox>
            <p class="body-2 mt-1">
              Dein Feedback ist goldwert! Hier profitierst du von Anleitungsvideos und einfacher Meinungsabgabe. Das Newsletter-Abo ist jederzeit kündbar und 100% frei von Spam.
            </p>
            <v-checkbox class="mt-n1" v-model="newsletter" label="Newsletter abonnieren" hide-details></v-checkbox>
          </v-col>
        </v-row>
        <v-row class="mt-0">
          <v-col>
            <v-btn color="gelb" class="full_width white--text" @click="register" :disabled="!valid">Jetzt gratis sichern</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-container class="pa-10" style="max-width: 400px;" v-else>
      <v-alert type="success">
        Dein Benutzeraccount wurde angelegt.
      </v-alert>
      <p>
        Wir haben dir eine Email mit einem Aktivierungslink an deine Emailadresse verschickt. Bitte prüfe auch den Spamordner.<br><br>
        Solltest Du das Email nicht innerhalb der nächsten Minuten erhalten, kannst Du es <router-link to="/verify">noch einmal anfordern.</router-link>
      </p>
      <v-row class="mt-5">
        <v-col>
          <v-btn color="gelb" class="full_width white--text" to="/login" >Zum Login</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

import CenterContainer from "@/components/CenterContainer";
export default {
  name: 'Registrieren',
  components: {CenterContainer  },
  data() {return{
    success:false,
    valid:false,
    email: '',
    emailRules: [
      v => !!v || 'Bitte ausfüllen',
      v => /.+@.+/.test(v) || 'Ungültige Email',
    ],

    pw1:'',
    pw2:'',
    pw1Rules: [
      v => !!v || 'Bitte ein Passwort wählen',
      v => (v && v.length >= 8) || 'Passwort muss aus mindestens 8 Zeichen bestehen',
      //v => /\d/.test(v) || 'Passwort muss mindestens eine Ziffer beinhalten',
      // v => /[A-Z]/.test(v) || 'Passwort muss mindestens einen Großbuchstaben beinhalten',
      // v => /[a-z]/.test(v) || 'Passwort muss mindestens einen Kleinbuchstaben beinhalten',
    ],
    pw2Rules: [
      v => !!v || 'Bitte nochmal eingeben',
      v => v==this.pw1 || 'Passwörter stimmen nicht überein',
    ],
    agreeDSB:false,
    agreeDSBrules: [
      v => !!v || 'Zustimmung ist erforderlich, um aimz zu nutzen',
    ],
    capslock:false,
    info:undefined,
    data:undefined,
    json: undefined,
    newsletter: false,
  }},
  mounted() {
    this.info=this.$route.params.data;
    if (this.info) {
      try {
        this.json = atob(this.info);
        this.data = JSON.parse(this.json);
        this.email=this.member;
        console.log("Signup data: ", this.data);
      }
      catch (e) {
        console.log(e);
      }
    }
    if (this.is_logged_in)
      this.$store.commit("logout");
    document.addEventListener( 'keydown', this.onKeyDown);
  },
  methods:{
    register() {
      this.$refs.form.validate();
      if (!this.valid)
        return;
      var newsletter=this.newsletter;
      this.$backend.register({ email:this.email, password: this.pw1, teamLeader:this.leader, newsletter }, { onSuccess:this.onSuccess, onError:this.onError });
    },
    onKeyDown( event ) {
      this.capslock = event.getModifierState && event.getModifierState( 'CapsLock' );
      //console.log( this.caps ); // true when you press the keyboard CapsLock key
    },
    onSuccess() {
      this.success=true;
    },
    onError() {
      this.email='';
      this.pw1='';
      this.pw2='';
      this.valid=false;
      this.$refs.form.reset();
    },
    onHasAccount(email) {
      if (email) {
        this.$router.replace("/login/"+email);
      }
    }
  },
  computed: {
    member() {
      return (this.data||{}).member;
    },
    leader() {
      return (this.data||{}).leader;
    },
    is_logged_in() {
      return !!this.$store.state.token;
    },
  },
  beforeDestroy() {
    document.removeEventListener( 'keydown', this.onKeyDown);
  },
}
</script>

<style>
  .rb {
    border: red 1px solid;
  }
  .full_width {
    width: 100%;
  }
</style>